import { Link } from "react-router-dom";
import "./HomePage.css";

function HomePage() {
  return (
    <div className="opening-page-container background">
      <img
        className="opening-page-pink"
        src={process.env.PUBLIC_URL + "Assets/Opening_Page.png"}
        alt="opening_page"
      ></img>
      <Link to="/game" className="start-game-link">
        <img
          className="start-game-btn"
          src={process.env.PUBLIC_URL + "Assets/start_game_btn.png"}
          alt="start_game_btn"
        ></img>
      </Link>
    </div>
  );
}

export default HomePage;
